import { getSafe, setSafe } from "../../../util/storeHelper";
import * as actions from "../actions/transferSetup";
const userlistReducer = {
    reducers: {
        [actions.setSource]: (state, payload) => {
            if (payload.pos !== undefined) {
                return setSafe(state, ["connection", "source"], payload);
            }
            else if (payload.id === getSafe(state, ["connection", "source", "id"], undefined)) {
                return setSafe(state, ["connection", "source"], undefined);
            }
            else {
                return state;
            }
        },
        [actions.setTarget]: (state, payload) => {
            if (payload.pos !== undefined &&
                (payload.id !== null ||
                    state.connection === undefined ||
                    state.connection.target === undefined ||
                    state.connection.target.id === undefined ||
                    state.connection.target.id === null)) {
                return setSafe(state, ["connection", "target"], payload);
            }
            else if (payload.id === getSafe(state, ["connection", "target", "id"], undefined)) {
                return setSafe(state, ["connection", "target"], undefined);
            }
            else {
                return state;
            }
        },
        [actions.setCreateTransfer]: (state, payload) => setSafe(state, ["dialog"], payload),
        [actions.closeDialog]: (state, payload) => setSafe(state, ["dialog"], undefined),
    },
    defaults: {
        connection: undefined,
        dialog: undefined,
    },
};
export default userlistReducer;
